<template>
  <card-seplag :titulo="'Ficha Financeira'" cor="#00acc1">
    <div class="p-lg-12 p-col-12 dashboard">
      <div class="summary-box summary-box-azul">
        <Card class="card">
          <template slot="content">
            <div class="p-grid">
              <div class="p-col-1 col-imagem">
                <i class="pi pi-user summary-box-icon"></i>
              </div>
              <div class="p-col-md-11 p-col-sm-12">
                <p class="summary-box-title">{{ dadosPessoa.nome }}</p>
                <p><strong>Matrícula:</strong> {{ dadosPessoa.matricula }}</p>
                <p><strong>Vínculo:</strong> {{ this.vinculo }}</p>
                <p><strong>CPF:</strong> {{ dadosPessoa.cpfFormatado }}</p>
                <p><strong>RG:</strong> {{ dadosPessoa.rg }}</p>
              </div>
            </div>
            <img
              src="../../../public/assets/layout/images/tmp/graph-messages.svg"
              alt="sapphire"
              class="summary-box-graph"
              width="20%"
            />
          </template>
        </Card>
      </div>
    </div>
    <div class="p-col-12">
      <div class="p-grid p-fluid">
        <Rotulo cols="12 6" v-if="listaAnoFichaFinanceira94.length > 0">
          <Fieldset
            class="p-col-12"
            legend="Ficha Financeira (Período de Novembro de 1994 a Abril de 2008 )"
            style=""
          >
            <Rotulo cols="12" nome="Informe o período desejado:">
              <Rotulo nome=""></Rotulo>
              <div class="p-grid p-fluid">
                <div class="col-12 md:col-4">
                  <div class="p-inputgroup date-picker-field">
                    <span class="p-inputgroup-addon">
                      <i
                        style="
                          margin-right: 10px;
                          margin-left: 5px;
                          font-size: 1.2rem;
                        "
                        class="pi pi-calendar"
                      >
                        Ano
                      </i>
                      <Datepicker
                        :value="anoInicio2"
                        :language="language"
                        minimum-view="year"
                        format="yyyy"
                        style="width: 60px"
                        input-class="input-year-class"
                        name="datepicker"
                        id="input-id"
                        class="yearPick"
                        :open-date="new Date(2008, 0, 0)"
                        :disabledDates="disabledDates94"
                        @selected="carregaValor2($event)"
                      />
                    </span>
                  </div>
                </div>
                <div style="margin-left: 15px" class="col-12 md:col-4">
                  <div class="p-inputgroup">
                    <Button
                      label="Gerar Relatório"
                      icon="pi pi-save"
                      class="p-button-primary"
                      @click="gerarPDF2()"
                    />
                  </div>
                </div>
              </div>
            </Rotulo>
          </Fieldset>
        </Rotulo>
        <Rotulo cols="12 6">
          <Fieldset
            class="p-col-12"
            legend="Ficha Financeira (Período de Maio 2008 a periodo atual)"
            style=""
          >
            <Rotulo cols="12" nome="Informe o período desejado:">
              <Rotulo nome=""></Rotulo>
              <div class="p-grid p-fluid">
                <div class="col-12 md:col-4">
                  <div class="p-inputgroup date-picker-field">
                    <span class="p-inputgroup-addon">
                      <i
                        style="
                          margin-right: 10px;
                          margin-left: 5px;
                          font-size: 1.2rem;
                        "
                        class="pi pi-calendar"
                      >
                        Ano
                      </i>
                      <Datepicker
                        :value="anoInicio"
                        :language="language"
                        minimum-view="year"
                        format="yyyy"
                        style="width: 60px"
                        name="datepicker"
                        id="input-id"
                        input-class="input-year-class"
                        class="yearPick"
                        :disabledDates="disabledDates2008"
                        :open-date="new Date()"
                        :disabled="datePicker2008Disabled"
                        @selected="carregaValor($event)"
                      />
                    </span>
                  </div>
                </div>
                <div style="margin-left: 15px" class="col-12 md:col-4">
                  <div class="p-inputgroup">
                    <Button
                      label="Gerar Relatório"
                      icon="pi pi-save"
                      class="p-button-primary"
                      @click="gerarPDF()"
                    />
                  </div>
                </div>
              </div>
            </Rotulo>
          </Fieldset>
        </Rotulo>
      </div>
    </div>
    <span class="foot-text-ficha"
      >Fichas financeiras de anos anteriores a 1994, deverão ser solicitadas
      pelo e-mail fichafinanceira@seplag.mt.gov.br</span
    >
    <CardExibirPDF
      v-if="pdfElement && navegador != 'Safari'"
      v-model="exibirPDF"
      :nomeDocumento="nomeDocumentoPDF"
      :tituloTela="'PDF do Documento Selecionado'"
      :position="'top'"
      :tamanhoTela="'95.em'"
      :alturaTela="'95.em'"
      :pdfElement="pdfElement"
    />
  </card-seplag>
</template>

<script>
import CardSeplag from "@/template/CardSeplag.vue";
import CardExibirPDF from "@/template/CardExibirPDF.vue";
import Rotulo from "@/template/RotuloSeplag.vue";
import moment from "moment";
import { baseApiUrl } from "@/config/global";
import Datepicker from "vuejs-datepicker";
import Button from "primevue/button/Button";

export default {
  name: "FichaFinanceira",
  components: { CardSeplag, CardExibirPDF, Rotulo, Datepicker, Button },
  data: function () {
    return {
      apiUrlRecurso: "fichafinanceira",
      anoInicioSeap: 2008,
      anoInicio: null,
      anoInicio2: null,
      anoFim: null,
      ano_atual: moment().format("YYYY"),
      listaAnoInicio: [],
      listaAnoFim: [],
      listaAnoFichaFinanceira94: [],
      listaAnoFichaFinanceira2008: [],
      dadosPessoa: [],
      numPensionista: null,
      matricula: null,
      vinculo: null,
      desabilitado: true,
      exibirPDF: false,
      nomeDocumentoPDF: "fichafinanceira",
      pdfElement: null,
      DatePickerFormat: "yyyy",
      language: {
        language: "portuguese",
        months: [
          "Janeiro",
          "Fevereiro",
          "Março",
          "Abril",
          "Maio",
          "Junho",
          "Julho",
          "Agosto",
          "Setembro",
          "Outubro",
          "Novembro",
          "Dezembro",
        ],
        monthsAbbr: [
          "Jan",
          "Fev",
          "Mar",
          "Abr",
          "Mai",
          "Jun",
          "Jul",
          "Ago",
          "Set",
          "Out",
          "Nov",
          "Dez",
        ],
        days: [
          "Domingo",
          "Segunda",
          "Terça",
          "Quarta",
          "Quinta",
          "Sexta",
          "Sábado",
        ],
        rtl: false,
        ymd: false,
        yearSuffix: " ",
        teste: [],
        valorAno: 1,
        valorAno2: 1,
        navegador: null,
      },
      disabledDates94: {
        to: null,
        from: null,
      },
      disabledDates2008: {
        to: null,
        from: null,
      },
      datePicker2008Disabled: false,
    };
  },
  beforeCreate() {
    let matricula = this.$store.getters.getMatricula;
    this.$http
      .get(`${baseApiUrl}/relatorios/anosficfinanceira94/${matricula}`)
      .then((res) => {
        this.listaAnoFichaFinanceira94 = res.data;
        this.disabledDates94.to = new Date(
          parseInt(this.listaAnoFichaFinanceira94[0]) + 1,
          0,
          0
        );
        this.disabledDates94.from = new Date(
          parseInt(
            this.listaAnoFichaFinanceira94[
              this.listaAnoFichaFinanceira94.length - 1
            ]
          ) + 1,
          0,
          0
        );
      });
    this.$http
      .get(`${baseApiUrl}/relatorios/anosficfinanceira2008/${matricula}`)
      .then((res) => {
        this.listaAnoFichaFinanceira2008 = res.data;

        if (this.listaAnoFichaFinanceira2008.length == 0) {
          this.datePicker2008Disabled = true;
        } else {
          this.disabledDates2008.to = new Date(
            parseInt(this.listaAnoFichaFinanceira2008[0]) + 1,
            0,
            0
          );
          this.disabledDates2008.from = new Date(
            parseInt(
              this.listaAnoFichaFinanceira2008[
                this.listaAnoFichaFinanceira2008.length - 1
              ]
            ) + 1,
            0,
            0
          );
        }
      });
  },
  mounted() {
    this.carregarDados();
    this.detectaNavegador();
  },
  methods: {
    async carregarDados() {
      this.matricula = await this.$store.getters.getMatricula;
      this.vinculo = await this.$store.getters.getVinculo;

      var usuario = this.$store.getters.getUser;
      var identificacao = usuario.contaAcesso.identificacao;
      this.numPensionista = identificacao
        ? usuario.dadosUsuariosCustomizados.pensionista.numeroPensionista
        : null;
      this.dadosPessoa = {
        matricula: this.matricula,
        vinculo: this.vinculo,
        cpf: usuario.dadosUsuariosCustomizados.pessoa.documentosPessoais.cpf,
        rg: usuario.dadosUsuariosCustomizados.pessoa.documentosPessoais.rg,
        nome: usuario.dadosUsuariosCustomizados.pessoa.nome,
        cpfFormatado:
          usuario.dadosUsuariosCustomizados.pessoa.documentosPessoais
            .cpfFormatado,
      };

      this.listaAnoInicio = this.gerarLista(this.anoInicioSeap, this.ano_atual);
    },

    carregarListaFim() {
      this.anoFim = null;
      this.listaAnoFim = this.gerarLista(this.anoInicio, this.ano_atual);
    },
    gerarLista(inicio, fim) {
      let incremento = parseInt(inicio);
      let lista = [];
      do {
        lista.push({ ano: incremento.toString() });
        incremento = incremento + 1;
      } while (incremento <= fim);

      return lista;
    },

    gerarPDF() {
      var usuario = this.$store.getters.getUser;
      let dadosPDF = {
        cpf: usuario.dadosUsuariosCustomizados.pessoa.documentosPessoais.cpf,
        matricula: this.$store.getters.getMatricula,
        anoMesInicio:
          this.valorAno == 2008 ? this.valorAno + "05" : this.valorAno + "01",
        anoMesFim: this.valorAno + "12",
      };
      if (this.valorAno >= 2008) {
        this.$http
          .post(
            `${baseApiUrl}/relatorios/fichafinanceira2008`,
            JSON.stringify(dadosPDF)
          )
          .then((res) => {
            this.pdfElement = res.data.dadosRelatorioBase64;
            this.nomeDocumentoPDF = res.data.nomeArquivo;
            this.exibirPDF = true;

            const byteCharacters = atob(res.data.dadosRelatorioBase64);
            const byteNumbers = new Array(byteCharacters.length);

            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: "application/pdf" });

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(blob, "fichafinaceira2008.pdf");
            } else {
              const objectUrl = URL.createObjectURL(blob);

              const link = document.createElement("a");
              link.href = objectUrl;
              link.download = "fichafinaceira2008.pdf";
              link.style.display = "none";

              if (this.detectaNavegador() === 4) {
                this.exibirPDF = false;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                setTimeout(() => {
                  window.open(objectUrl, "_blank");
                }, 1000);
              }
              setTimeout(() => {
                URL.revokeObjectURL(objectUrl);
              }, 2000);
            }
          });
      }
    },
    gerarPDF2() {
      var usuario = this.$store.getters.getUser;
      let dadosPDF = {
        cpf: usuario.dadosUsuariosCustomizados.pessoa.documentosPessoais.cpf,
        matricula: this.$store.getters.getMatricula,
        anoMesInicio: this.valorAno2 + "01",
        anoMesFim:
          this.valorAno2 == 2008
            ? this.valorAno2 + "04"
            : this.valorAno2 + "12",
      };
      if (this.valorAno2 <= 2008) {
        this.$http
          .post(
            `${baseApiUrl}/relatorios/fichafinanceira94`,
            JSON.stringify(dadosPDF)
          )
          .then((res) => {
            this.pdfElement = res.data.dadosRelatorioBase64;
            this.nomeDocumentoPDF = res.data.nomeArquivo;
            this.exibirPDF = true;

            const byteCharacters = atob(res.data.dadosRelatorioBase64);
            const byteNumbers = new Array(byteCharacters.length);

            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: "application/pdf" });

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(blob, "fichafinaceira94.pdf");
            } else {
              const objectUrl = URL.createObjectURL(blob);

              const link = document.createElement("a");
              link.href = objectUrl;
              link.download = "fichafinaceira94.pdf";
              link.style.display = "none";

              if (this.detectaNavegador() === 4) {
                this.exibirPDF = false;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                setTimeout(() => {
                  window.open(objectUrl, "_blank");
                }, 1000);
              }

              setTimeout(() => {
                URL.revokeObjectURL(objectUrl);
              }, 2000);
            }
          });
      }
    },
    carregaValor(e) {
      this.anoInicio = e;
      this.teste = String(e);
      var testeSplit = this.teste.split(" ");
      this.valorAno = testeSplit[3];
    },
    carregaValor2(e) {
      this.anoInicio2 = e;
      this.teste = String(e);
      var testeSplit = this.teste.split(" ");
      this.valorAno2 = testeSplit[3];
    },
    detectaNavegador() {
      var isOpera = !!window.opera || navigator.userAgent.indexOf(" OPR/") >= 0;
      var isFirefox = typeof InstallTrigger !== "undefined"; // Firefox 1.0+
      var isChrome = !!window.chrome && !isOpera; // Chrome 1+
      var isIE = /*@cc_on!@*/ false || !!document.documentMode; // At least IE6

      var userAgent = navigator.userAgent;
      var isSafari =
        userAgent.indexOf("Safari") >= 0 && userAgent.indexOf("Chrome") === -1;

      if (isOpera) {
        this.navegador = "Opera";
        return 1;
      } else if (isFirefox) {
        this.navegador = "Firefox";
        return 2;
      } else if (isChrome) {
        this.navegador = "Chrome";
        return 3;
      } else if (isSafari) {
        this.navegador = "Safari";
        return 4;
      } else if (isIE) {
        this.navegador = "IE";
        return 5;
      } else {
        this.navegador = "OUTRO";
        return 0;
      }
    },
  },
};
</script>

<style>
.foot-text-ficha {
  font-size: 1.15rem;
  font-weight: bold;
}
.date-picker-field {
  font-size: 12px;
  height: 35px;
}

.input-year-class {
  width: 60px;
  font-size: 1.15rem;
  text-align: center;
}

.dashboard .dashboard-grid {
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  padding: 0;
}

.dashboard .card {
  height: 100%;
  margin-bottom: 0;
}

.dashboard .summary-box {
  position: relative;
}

.dashboard .summary-box .card {
  min-height: 100px;
}

.dashboard .summary-box .summary-box-title {
  font-size: 2em;
  margin: 0;
  color: #ffffff;
}

.dashboard .summary-box p {
  margin: 0.25em 0;
  color: #ffffff;
}

.col-imagem {
  display: inline;
}

.dashboard .summary-box .summary-box-icon {
  font-size: 8em;
  color: #ffffff;
}

.dashboard .summary-box .summary-box-graph {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
}

.dashboard .summary-box.summary-box-azul .card {
  border-top: 4px solid #0097a7;
  background-color: #00bcd4;
}

.dashboard .summary-box.summary-box-azul .ico {
  color: #0097a7;
}

@media screen and (max-width: 1600px) {
  .dashboard .summary-box .summary-box-icon {
    font-size: 6em;
    margin-top: 27px;
  }

  .col-imagem {
    display: none;
  }
}

@media screen and (max-width: 780px) {
  body .p-component {
    font-size: 12px;
  }

  .p-datatable-responsive .p-datatable-thead > tr > th,
  .p-datatable-responsive .p-datatable-tfoot > tr > td {
    display: none !important;
  }

  .p-datatable-responsive .p-datatable-tbody > tr > td {
    text-align: left;
    display: block;
    border: 0 none;
    width: 100% !important;
    float: left;
    clear: left;
  }

  .p-datatable-responsive .p-datatable-tbody > tr > td .p-column-title {
    padding: 0.4em;
    min-width: 30%;
    display: inline-block;
    margin: -0.4em 1em -0.4em -0.4em;
    font-weight: bold;
  }

  body .p-datatable .p-datatable-header {
    border-bottom: 1px solid #c8c8c8;
  }

  .yearPick {
    align-items: center;
    text-align: center;
    width: 100%;
    margin-left: 15px;
  }

  .vdp-datepicker__calendar {
    position: fixed;
    z-index: 100;
    background: #fff;
    width: 300px;
    border: 1px solid #ccc;
    padding-right: 120px;

    /* Propriedades para posicionar no meio da tela */
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
